import Vue from 'vue'
import VueI18n from 'vue-i18n'
import swal from 'sweetalert2'

Vue.use(VueI18n)

const { locale, translations } = window.config
const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency', currency: 'USD'
        }
    }
}

const i18n = new VueI18n({
    locale,
    numberFormats,
    messages: {
        [locale]: translations
    }
})

swal.i18n = i18n
swal.setDefaults({
    reverseButtons: true,
    confirmButtonText: i18n.t('ok'),
    cancelButtonText: i18n.t('cancel')
})

export default i18n



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vue-i18n.js